import { render } from "./ActiveApprovalPendingCases.vue?vue&type=template&id=2a182e24"
import script from "./ActiveApprovalPendingCases.vue?vue&type=script&lang=js"
export * from "./ActiveApprovalPendingCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pendingCases/ActiveApprovalPendingCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a182e24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a182e24', __exports__)) {
    console.log('reload')
    api.reload('2a182e24', __exports__)
  }
  
  module.hot.accept("./ActiveApprovalPendingCases.vue?vue&type=template&id=2a182e24", () => {
    console.log('re-render')
    api.rerender('2a182e24', render)
  })

}


export default __exports__